import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg className="radialGradient" width="256" height="256" viewBox="0 0 256 256" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <circle cx="128" cy="128" r="128" fill="url(#paint0_radial)"/>
      <defs>
        <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(128 128) rotate(90) scale(128)">
          <stop stopColor="#1A98FF"/>
          <stop offset="1" stopColor="#1A98FF" stopOpacity="0"/>
        </radialGradient>
      </defs>
    </svg>
)
